import { SET_MODAL, CLOSE_MODAL, MINIMIZE_MODAL, MAXIMIZE_MODAL } from './GLobalModalTypes.js'

export const setModal = (data) => (dispatch) => {
  dispatch({
    type: SET_MODAL,
    payload: data,
  })
}

export const closeModal = (id) => (dispatch) => {
  dispatch({
    type: CLOSE_MODAL,
    payload: id,
  })
}

export const setTest = (data) => (dispatch) => {
  dispatch({
    type: 'test',
    payload: data,
  })
}

export const minimizeModal = (id) => (dispatch) => {
  dispatch({
    type: MINIMIZE_MODAL,
    payload: id,
  })
}

export const maximizeModal = (id) => (dispatch) => {
  dispatch({
    type: MAXIMIZE_MODAL,
    payload: id,
  })
}
